import type { MantineColorsTuple } from "@mantine/core";

export type BrandingConfig = {
  primaryColorName: string;
  themeName: string;
  palette: MantineColorsTuple;
  gradient: {
    from: string;
    to: string;
    deg: number;
  };
};

export const branding: BrandingConfig = {
  primaryColorName: "brand",
  themeName: "Violet Slate",
  palette: [
    "#EEF0FD",
    "#DDE1FB",
    "#B8C0F5",
    "#939FEF",
    "#7483E8",
    "#5E6AD2",
    "#4F5ABF",
    "#404BAC",
    "#313C99",
    "#222D86",
  ] as const satisfies MantineColorsTuple,
  gradient: { from: "#7483E8", to: "#404BAC", deg: 135 },
};

